module.exports = __webpack_public_path__ + "static/media/mission.9dfe38f4.png";